package com.parmartechnologies.storage.table.inventory.tag

import com.parmartechnologies.core.feature.inventory.tag.model.Tag
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable

class TagDatabaseTable : DatabaseTable() {

    fun insert(item: Tag?) {
        item?.let {
            DatabaseCollection().insert(item, Tag.serializer())
        }
    }

    fun insert(items: List<Tag>?, callback: () -> Unit) {
        items?.let {
            DatabaseCollection().insertAll(items, Tag.serializer())
        }
    }

    fun retrieve(id: String, callback: (List<Tag>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id, Tag.serializer()){
            callback(it)
        }
    }

    fun find(id: String, callback: (Tag?) -> Unit) {
        DatabaseCollection().findOne(id, Tag.serializer()){
            callback(it)
        }
    }


    fun LastSyncDate(id: String, callback: (String?) -> Unit) {
        callback("")
    }
}